/* eslint-disable */
/// This file is auto generated - do not edit manually
export const EmailNotValid = 'Website.ProductCustomerNotification.Error.EmailNotValid';
